import axios from 'axios';
import { Box } from '@amzn/awsui-components-react';
import React from 'react';
import { withCookies } from 'react-cookie';
import {
  Alert,
  Button,
  ColumnLayout,
  FormField,
  Header,
  Input,
  Modal,
  Spinner,
} from '@amzn/awsui-components-react';

import { Container } from '@amzn/awsui-components-react';
import {
  API_ENDPOINT,
  ERROR_MESSAGE_INVALID_CREDENTIALS,
  ERROR_MESSAGE_SERVICE_API_ERROR,
} from '../constants';

class AdAuthForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enableLoginButton: false,
      errorMessage: null,
      isLoading: false,
      username: '',
      password: '',
      mfaStaticChallenge: null,
    };
    this.onClick = this.onClick.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onAlertDismiss = this.onAlertDismiss.bind(this);
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onMfaStaticChallengeChange = this.onMfaStaticChallengeChange.bind(
      this,
    );
  }

  render() {
    return (
      <Modal
        visible={true}
        header={`AD authentication for ${this.props.endpointId}`}
        footer={
          <>
            {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
            <Box margin={{ bottom: 'xs' }}>
              <Alert
                type="error"
                visible={!!this.state.errorMessage}
                onDismiss={this.onAlertDismiss}
              >
                {this.state.errorMessage}
              </Alert>
            </Box>
            <Box variant="span" float="right">
              <Button variant="link">Cancel</Button>
              <Button
                variant="primary"
                disabled={!this.state.enableLoginButton}
                onClick={this.onClick}
              >
                {this.state.isLoading ? <Spinner></Spinner> : 'Login'}
              </Button>
            </Box>
          </>
        }
        onDismiss={this.onDismiss}
      >
        <Container
          header={<Header variant="h2">Log in to your corporate AD</Header>}
        >
          <ColumnLayout columns={2}>
            <div>
              <FormField label="Username"></FormField>
            </div>
            <div>
              <Input
                value={this.state.username}
                onChange={this.onUsernameChange}
              />
            </div>
            <div>
              <FormField label="Password"></FormField>
            </div>
            <div>
              <Input
                type="password"
                value={this.state.password}
                onChange={this.onPasswordChange}
              />
            </div>
            {this.props.adAuth.mfaEnabled ? (
              <>
                <div>
                  <FormField label="MFA Static Challenge"></FormField>
                </div>
                <div>
                  <Input
                    type="password"
                    value={this.state.mfaStaticChallenge}
                    onChange={this.onMfaStaticChallengeChange}
                  />
                </div>
              </>
            ) : null}
          </ColumnLayout>
        </Container>
      </Modal>
    );
  }

  onClick(e) {
    this.setState({
      enableLoginButton: false,
      errorMessage: null,
      isLoading: true,
    });
    axios({
      method: 'post',
      url: `${API_ENDPOINT}/endpoints/${this.props.endpointId}/authentication/ad`,
      data: {
        Username: this.state.username,
        Password: this.state.password,
        MFAStaticChallenge: this.state.mfaStaticChallenge,
      },
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        this.handleSuccessfulAdAuthResponse(response);
      })
      .catch((error) => {
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data['Message']) ||
          ERROR_MESSAGE_SERVICE_API_ERROR;
        const statusCode = (error.response && error.response.status) || 500;
        this.setState({
          enableLoginButton: true,
          errorMessage:
            statusCode === 401
              ? ERROR_MESSAGE_INVALID_CREDENTIALS
              : errorMessage,
          isLoading: false,
        });
      });
  }

  onUsernameChange(e) {
    const username = e.detail.value;
    const isMfaEnabled = this.props.adAuth.mfaEnabled;
    this.setState((state) => ({
      username: username,
      enableLoginButton:
        username &&
        state.password &&
        (!isMfaEnabled || state.mfaStaticChallenge),
    }));
  }

  onPasswordChange(e) {
    const password = e.detail.value;
    const isMfaEnabled = this.props.adAuth.mfaEnabled;
    this.setState((state) => ({
      password: password,
      enableLoginButton:
        state.username &&
        password &&
        (!isMfaEnabled || state.mfaStaticChallenge),
    }));
  }

  onMfaStaticChallengeChange(e) {
    const mfaStaticChallenge = e.detail.value;
    const isMfaEnabled = this.props.adAuth.mfaEnabled;
    this.setState((state) => ({
      mfaStaticChallenge: mfaStaticChallenge,
      enableLoginButton:
        state.username &&
        state.password &&
        (!isMfaEnabled || mfaStaticChallenge),
    }));
  }

  onAlertDismiss() {
    this.setState({ errorMessage: null });
  }

  onDismiss(e) {
    window.location.href = '/';
  }

  handleSuccessfulAdAuthResponse(response) {
    window.location.reload(false);
  }
}

export default withCookies(AdAuthForm);
